  let detailMenuItems = document.querySelectorAll(".header__inline-menu details");
  detailMenuItems.forEach((menuItem) => {
      let dropdown = menuItem.querySelector("ul");
      if (!dropdown) return;
      menuItem.addEventListener("mouseover", () => {
          menuItem.setAttribute("open", true);
          dropdown.classList.add("dropdown-visible");
      });
      menuItem.addEventListener("mouseleave", () => {
          dropdown.classList.remove("dropdown-visible");     
          setTimeout(() => {
              if (!dropdown.matches(":hover")) {
                  menuItem.removeAttribute("open");
              }
          }, 300);
      });
  });

  